import React, { useCallback } from 'react';
import { SearchField, SearchFieldOnResultsPicked, SearchFieldProps } from './SearchField';
import { SearchDatabaseResultItem, MeiliIndex } from './types';
import { TypedMemo } from '../../../common/types';

export type SingleSearchFieldProps = Omit<SearchFieldProps, 'onResultPicked' | 'queryTypes' | 'isSimple'> & {
  queryType: MeiliIndex;
  onSelected: (item: SearchDatabaseResultItem) => void;
};

const SingleSearchFieldComponent: React.FC<SingleSearchFieldProps> = ({ onSelected, queryType, ...props }) => {
  const onResultsPicked: SearchFieldOnResultsPicked = useCallback(
    (data) => {
      onSelected(data.suggestion);
    },
    [onSelected]
  );

  return (
    <SearchField
      onResultPicked={onResultsPicked}
      queryTypes={[queryType]}
      isSimple
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    />
  );
};

export const SingleSearchField = TypedMemo(SingleSearchFieldComponent);
